import { Component } from "@angular/core";
import { spaceAfterDataService } from '../../../services/spaceAfterDataService/spaceAfterData.service';
import {  OrderOperationType } from '../../modals/orderentry/orderentry.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ShowModalOrderEntry } from "../../modals/orderentry/show-order-entry-modal";
import { WorkspaceServiceService } from "../../../services/workspace-service.service";


@Component({
    selector: "toprightmenubar",
    template: require('./topRightMenuBar.component.html'),
    styles: [
        require('../navmenu.component.css')
    ]
})

export class topRightMenuBar {
    constructor(private modalService: NgbModal, protected workspaceService: WorkspaceServiceService)
    {

    }

    public showModalOrderEntry(): void {
        ShowModalOrderEntry('', 0, this.modalService, OrderOperationType.Buy, this.workspaceService.data.mobileMode,undefined,this.workspaceService.data.newOrderLayout);
    }


}

